<template>
  <div>
    <Breadcrumb msg1="商品库存" msg2="商品分类" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="6">
          <el-button type="success" icon="el-icon-plus" @click="add">新增分类</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border row-key="id" default-expand-all>
        <el-table-column label="分类名称" prop="name"></el-table-column>
        <el-table-column label="类型" prop="type" width="120"></el-table-column>
        <el-table-column label="上级分类" width="140"><template slot-scope="scope">{{ parentName(scope.row.parentId) }}</template></el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="del(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="show" width="500px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px" v-if="show">
        <el-form-item label="分类名称" required><el-input v-model="form.name"></el-input></el-form-item>
        <el-form-item label="上级分类">
          <el-select v-model="form.parent_id" clearable style="width: 100%">
            <el-option v-for="c in list" :key="c.id" :label="c.name" :value="c.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="form.type" style="width: 100%">
            <el-option label="商品" value="商品"></el-option>
            <el-option label="项目" value="项目"></el-option>
            <el-option label="镜片" value="镜片"></el-option>
            <el-option label="镜架" value="镜架"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="show = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data () {
    return {
      list: [],
      show: false,
      dialogTitle: '',
      form: {}
    }
  },
  created () { this.getData() },
  methods: {
    parentName (pid) { if (!pid) return ''; const p = this.list.find(x => x.id === pid); return p ? p.name : '' },
    getData () {
      this.$axios.http.get('/categories').then(res => {
        if (res.data.status === 200) this.list = res.data.data || []
      })
    },
    add () {
      this.dialogTitle = '新增分类'
      this.form = { name: '', parent_id: null, type: '商品' }
      this.show = true
    },
    edit (row) {
      this.dialogTitle = '编辑分类'
      this.form = Object.assign({}, row, { parent_id: row.parentId })
      this.show = true
    },
    save () {
      if (!this.form.name) { this.$message.warning('名称必填'); return }
      if (this.form.id) {
        this.$axios.put(`/categories/${this.form.id}`, () => { this.show = false; this.getData() }, this.form)
      } else {
        this.$axios.post('/categories', () => { this.show = false; this.getData() }, this.form)
      }
    },
    del (id) {
      this.$axios.del(`/categories/${id}`, () => this.getData())
    }
  }
}
</script>
